// TODO: add google analytics

/*
 * instantapp
 *
 * An abstraction for instant application features
 */

let promptEvent = null;


/*
 * handlePromptEvent
 *
 * @promptEvent
 *
 * Handle choice
 */
const handlePromptEvent = (promptEvent = {}) => {
    // eslint-disable-next-line no-unused-vars
    const platform = promptEvent.platforms;

    if (promptEvent.userChoice) {
        promptEvent.userChoice.then((choice) => {
            // eslint-disable-next-line no-unused-vars
            const { outcome } = choice;
        });
    }
};

/*
 * triggerPromptEvent
 *
 * Triggers instant application banner manually if promptEvent is set
 */
const triggerPromptEvent = () => {
    try {
        promptEvent.prompt();

        handlePromptEvent(promptEvent);
    } catch (error) {
        console.error('ERROR @triggerPromptEvent', error);
    }
};

/*
 * registerBeforeInstallListener
 *
 * @preventDefault (bool)
 * Determines weather of not to trigger the prompt event manually via triggerPromptEvent
 *
 * Captures the browser event
 */
const registerBeforeInstallListener = (preventDefault = false) => {
    window.addEventListener('beforeinstallprompt', (event) => {
        if (preventDefault) {
            event.preventDefault();

            // store event
            promptEvent = event;
            return;
        }
        handlePromptEvent(event);
    });
};

const registerAppInstalledListener = () => {
    // does not work
    window.addEventListener('appinstalled', () => {
        // app was installed
    });
};

export default {
    registerBeforeInstallListener,
    registerAppInstalledListener,
    triggerPromptEvent,
};
